<nz-upload
  #uploadComponent
  nzMultiple="true"
  nzLimit="10"
  nzSize="50000"
  [nzCustomRequest]="props.handleUpload"
  [nzDisabled]="props.disabled"
  [nzFileListRender]="nzUploadFileListTemplate"
  [(nzFileList)]="fileList"
  (nzChange)="handleChange()"
>
  <ng-template #nzUploadFileListTemplate let-previews>
    <div data-test-id="fileList" class="flex w-full flex-col gap-4">
      @for (preview of previews; track preview) {
        <div
          class="flex items-center gap-5 rounded-lg border-2 border-grey-300 bg-grey-50 px-5 py-4"
        >
          @if (preview.status === 'error') {
            <svg-icon
              class="text-red-600"
              src="assets/icons/Files/file-question-03.svg"
            />
            <div class="flex grow flex-col">
              <div class="font-medium break-all">{{ preview.name }}</div>
              <div data-test-id="errorMessage" class="text-xs text-red-600">
                {{ preview.error.message }}
              </div>
            </div>
          } @else {
            <svg-icon
              class="text-grey-300"
              src="assets/icons/Files/file-05.svg"
            />
            <div class="flex grow flex-col">
              <div class="font-medium break-all">{{ preview.name }}</div>
              <div class="text-xs text-grey-500">
                {{ preview.size | nzBytes }} -
                <span
                  class=""
                  [ngClass]="{
                    'text-orange-600': preview.percent < 100,
                    'text-green-600': preview.percent === 100,
                  }"
                >
                  {{ preview.percent }}%
                </span>
                {{ progressbar.nzStatus }}
              </div>
              <nz-progress
                #progressbar
                nzStrokeWidth="4"
                nzSize="small"
                [nzPercent]="preview.percent"
                [nzShowInfo]="false"
              />
            </div>
          }

          <app-button
            type="transparent"
            shape="circle"
            title="Dokument entfernen"
            data-test-id="removeButton"
            (click)="removeFile(preview)"
            (keydown.enter)="removeFile(preview)"
          >
            <svg-icon
              class="text-grey-600"
              src="assets/icons/General/x-circle.svg"
            />
          </app-button>
        </div>
      }
    </div>
  </ng-template>

  <app-button
    class="mb-4 block [&>button]:border-blue-600 [&>button]:font-medium [&>button]:text-blue-600"
    type="outline"
    [disabled]="props.disabled ?? false"
  >
    <svg-icon src="assets/icons/General/upload-01.svg" />
    Dateien auswählen
  </app-button>
</nz-upload>
